/*
 * Copyright (c) 2024-2026, s0up and the autobrr contributors.
 * SPDX-License-Identifier: GPL-2.0-or-later
 */

import { getApiUrl } from "@/utils/baseUrl";

export interface AdGuardCount {
  domain: string;
  count: number;
}

export interface AdGuardStats {
  configured: boolean;
  error?: string;
  queries: number;
  blocked: number;
  avgMs: number;
  series: number[] | null;
  topBlocked: AdGuardCount[] | null;
  topQueried: AdGuardCount[] | null;
}

export async function getAdGuardStats(): Promise<AdGuardStats> {
  const res = await fetch(getApiUrl("/adguard/stats"), { credentials: "include" });
  if (!res.ok) throw new Error("Failed to load DNS statistics");
  return res.json();
}
